import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ApiService } from '../services/api.service';
import { StorageService } from '../services/storage.service';

function isAuthorizedOk(res: unknown): boolean {
  if (res === true) return true;
  return !!(res && typeof res === 'object' && (res as { result?: boolean }).result === true);
}

export const authGuard: CanActivateFn = () => {
  const apiService = inject(ApiService);
  const storageService = inject(StorageService);
  const router = inject(Router);

  const user = storageService.getUser();
  const token = storageService.getToken();
  if (!user?.id || !token) {
    storageService.clearStorage();
    router.navigate(['/backoffice/login']);
    return false;
  }

  return apiService.isAuthorized().pipe(
    map((res) => {
      if (!isAuthorizedOk(res)) {
        storageService.clearStorage();
        router.navigate(['/backoffice/login']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      storageService.clearStorage();
      router.navigate(['/backoffice/login']);
      return of(false);
    }),
  );
};
